<template>
  <div>
    <h1>项目效果</h1>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="less" scoped>

</style>